import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const isValidEmail: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp = `^([a-zA-Z0-9._+%-]+@[a-zA-Z0-9.-]+[.][a-zA-Z]{2,4})$`;
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { invalidEmail: true };
};
